import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // List of paths that should NOT scroll to top
    const excludedPaths = [
      '/admin',
      '/search',
      '/cancel-order',
      '/cancel-success',
      '/return-order',
      '/return-success',
      '/track'
    ];

    // Check if current path should be excluded
    const shouldExclude = excludedPaths.some(path => pathname.startsWith(path));

    if (!shouldExclude) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'smooth' for smooth scrolling
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;